// src/components/Common/AuthorLink.jsx
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import HomeIcon from '@mui/icons-material/Home';

/**
 * AuthorLink
 * - 닉네임을 파란 링크 + 팝오버(작성글 보기)로 표시
 * - disabled == true 이면 평문 텍스트만 반환
 * - sx prop 으로 fontWeight 등 외부 스타일 덮어쓰기가 가능
 *
 *   <AuthorLink nickname="홍길동" disabled={false} />                 // 목록 기본
 *   <AuthorLink nickname="홍길동" disabled={false}
 *               sx={{ fontWeight: 'bold' }} />                       // 헤더 볼드
 */
export default function AuthorLink({ nickname, username, disabled, sx: sxProp = {} }) {
    const [anchorEl, setAnchorEl] = useState(null);

    /* 익명 글이면 링크 없이 텍스트만 */
    if (disabled) return <span>{nickname}</span>;

    /* 클릭 → 팝오버 열기 */
    const handleOpen = (e) => {
        e.preventDefault();      // 기본 <a> 네비 차단
        e.stopPropagation();     // 부모 클릭 버블링 차단
        setAnchorEl(e.currentTarget);
    };

    /* 팝오버 닫기 */
    const handleClose = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        setAnchorEl(null);
    };

    return (
        <>
            {/* 닉네임 링크 */}
            <Typography
                component="span"
                variant="inherit"
                onClick={handleOpen}
                sx={{
                    fontWeight: 400,          // 기본 normal
                    color: 'primary.main',
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                    ...sxProp,                // ⭐ 외부에서 덮어쓰기
                }}
            >
                {nickname}
            </Typography>

            {/* 팝오버 메뉴 */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{ dense: true, onClick: handleClose }}
            >
                {/* 작성글 보기 */}
                <MenuItem
                    component={RouterLink}
                    to={`/main/board?page=1&search=${encodeURIComponent(nickname ?? '')}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <ListItemIcon><ArticleIcon fontSize="small" /></ListItemIcon>
                    <ListItemText primary="작성글 보기" />
                </MenuItem>

                {/* 미니홈 가기: nickname이 있을 때만 노출 */}
                {(nickname ?? '').trim() && (
                    <MenuItem
                        component={RouterLink}
                        to={`/u/${encodeURIComponent((nickname ?? '').trim())}/home`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <ListItemIcon><HomeIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="미니홈 가기" />
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}
